import { IS_MOBILE } from "@/lib/environmentDetector";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/primitives/dialog";

import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/primitives/drawer";
import ReactionsContent from "./ReactionsContent";

type Props = {
  open: boolean;
  onOpenClose: (open: boolean) => void;
  chatId: string;
  messageId: string;
  reactions?: Record<string, number>;
};
export default function ReactionsDialog({
  open,
  onOpenClose,
  chatId,
  messageId,
  reactions,
}: Props) {
  // const { t } = useTranslation();
  // const [isLoading, setIsLoading] = useState(false);

  const summary = Object.entries(reactions || {});

  if (!reactions) {
    onOpenClose(false);
    return null;
  }

  if (IS_MOBILE) {
    return (
      <Drawer
        open={open}
        onOpenChange={(isOpen) => {
          // if (isLoading) {
          //   return;
          // }
          onOpenClose(isOpen);
        }}
      >
        <DrawerContent
          aria-describedby="reactions-content"
          className="px-4 pb-4"
        >
          <DrawerHeader>
            <DrawerTitle />
            <DrawerDescription />
          </DrawerHeader>
          <ReactionsContent
            reactionSummary={summary}
            chatId={chatId}
            messageId={messageId}
          />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        // if (isLoading) {
        //   return;
        // }
        onOpenClose(isOpen);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle />
          <DialogDescription />
        </DialogHeader>

        <ReactionsContent
          reactionSummary={summary}
          chatId={chatId}
          messageId={messageId}
        />
      </DialogContent>
    </Dialog>
  );
}
